"use strict";

var _defineProperty = require("/home/maxwell/maxwell-sms-shopify-app/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/home/maxwell/maxwell-sms-shopify-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/home/maxwell/maxwell-sms-shopify-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorFactory = void 0;

var tslib_1 = require("tslib");

var hsluv_1 = require("hsluv");

var base_1 = require("./configs/base");

function colorFactory(theme, scheme) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : base_1.config;
  return Object.assign.apply(Object, [{}].concat(_toConsumableArray(Object.entries(theme).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        role = _ref2[0],
        hex = _ref2[1];

    if (typeof hex !== 'string') {
      return null;
    }

    var base = hsluv_1.hexToHsluv(hex);
    var variants = config[role] || [];
    return Object.assign({}, variants.reduce(function (accumulator, _a) {
      var name = _a.name,
          settings = tslib_1.__rest(_a, ["name"]);

      var _settings$scheme = settings[scheme],
          _settings$scheme$hue = _settings$scheme.hue,
          hue = _settings$scheme$hue === void 0 ? base[0] : _settings$scheme$hue,
          _settings$scheme$satu = _settings$scheme.saturation,
          saturation = _settings$scheme$satu === void 0 ? base[1] : _settings$scheme$satu,
          _settings$scheme$ligh = _settings$scheme.lightness,
          lightness = _settings$scheme$ligh === void 0 ? base[2] : _settings$scheme$ligh,
          _settings$scheme$alph = _settings$scheme.alpha,
          alpha = _settings$scheme$alph === void 0 ? 1 : _settings$scheme$alph;

      var resolve = function resolve(value, baseToResolve) {
        return typeof value === 'number' ? value : value(baseToResolve);
      };

      var _hsluv_1$hsluvToRgb$m = hsluv_1.hsluvToRgb([resolve(hue, base[0]), resolve(saturation, base[1]), resolve(lightness, base[2])]).map(function (channel) {
        return Math.round(channel * 255);
      }),
          _hsluv_1$hsluvToRgb$m2 = _slicedToArray(_hsluv_1$hsluvToRgb$m, 3),
          red = _hsluv_1$hsluvToRgb$m2[0],
          green = _hsluv_1$hsluvToRgb$m2[1],
          blue = _hsluv_1$hsluvToRgb$m2[2];

      return Object.assign(Object.assign({}, accumulator), _defineProperty({}, name, "rgba(".concat(red, ", ").concat(green, ", ").concat(blue, ", ").concat(alpha, ")")));
    }, {}));
  }))));
}

exports.colorFactory = colorFactory;